import { createRoutine } from 'redux-saga-routines';

export const fetchCandidatesRoutine = createRoutine('FETCH_CANDIDATES');
export const fetchCandidateCountersRoutine = createRoutine('FETCH_COUNTERS');

export const fetchPositionsRoutine = createRoutine('FETCH_POSITIONS');
export const fetchPositionCountersRoutine = createRoutine('FETCH_POSITION_COUNTERS');

export const fetchSurveysRoutine = createRoutine('FETCH_SURVEYS');
export const markSurveyAsFavoriteRoutine = createRoutine('MARK_SURVEY_AS_FAVORITE');

export const updateCandidateFilterRoutine = createRoutine('UPDATE_CANDIDATE_FILTER');
export const updatePositionFilterRoutine = createRoutine('UPDATE_POSITION_FILTER');
export const updateSurveyFilterRoutine = createRoutine('UPDATE_SURVEY_FILTER');
export const updateProspectFilterRoutine = createRoutine('UPDATE_PROSPECT_FILTER');

export const fetchProspectsRoutine = createRoutine('FETCH_PROSPECTS');
export const changeProspectStatusRoutine = createRoutine('CHANGE_PROSPECT_STATUS');
export const fetchProspectCountersRoutine = createRoutine('FETCH_PROSPECT_COUNTERS');

export const showContactProfileRoutine = createRoutine('SHOW_CONTACT');

export const hideContactProfileRoutine = createRoutine('HIDE_CONTACT');
